<div class="collections-addresses rounded p-6" [formGroup]="addressesForm">
  <h3 class="mb-6 body-400">Addresses</h3>
  <div class="row">
    <div class="col-6">
      <label class="tc--xdark mb-2">From name</label>
      <input
        type="text"
        class="form-input"
        [ngClass]="{ 'form-input--invalid': fromNameControl.invalid && fromNameControl.touched }"
        formControlName="fromName"
        placeholder="Firm Name"
      />
      <ng-container *ngIf="fromNameControl.invalid && fromNameControl.touched">
        <div *ngIf="fromNameControl.hasError('required')" class="invalid-feedback">Required</div>
        <div *ngIf="fromNameControl.hasError('email')" class="invalid-feedback">Invalid Email</div>
      </ng-container>
    </div>
    <div class="col-6">
      <label class="tc--xdark mb-2">From address</label>
      <input
        type="text"
        class="form-input"
        [ngClass]="{
          'form-input--invalid': replyToAddressControl.invalid && (replyToAddressControl.touched || replyToAddressControl.dirty),
        }"
        formControlName="replyToAddress"
        placeholder="support@firm-domain.com"
      />
      <ng-container *ngIf="replyToAddressControl.invalid && (replyToAddressControl.touched || replyToAddressControl.dirty)">
        <div *ngIf="replyToAddressControl.hasError('required')" class="invalid-feedback">Required</div>
        <div *ngIf="replyToAddressControl.hasError('email')" class="invalid-feedback">Invalid Email</div>
      </ng-container>
    </div>
  </div>
  <div *ngIf="includeCcAndBcc$ | async" class="row mt-6">
    <div class="col-6">
      <label class="tc--xdark mb-2">Cc recipients</label>
      <input
        type="text"
        class="form-input mb-2"
        [ngClass]="{ 'form-input--invalid': ccRecipientsControl.invalid && (ccRecipientsControl.touched || ccRecipientsControl.dirty) }"
        formControlName="ccRecipients"
        placeholder="email@example.com"
      />
      <ng-container *ngIf="ccRecipientsControl.invalid && (ccRecipientsControl.touched || ccRecipientsControl.dirty)">
        <div *ngIf="ccRecipientsControl.hasError('email')" class="invalid-feedback">Invalid Email</div>
      </ng-container>
      <mat-hint>Comma-separated for multiple recipients</mat-hint>
    </div>
    <div class="col-6">
      <label class="tc--xdark mb-2" for="bccRecipients">Bcc recipients</label>
      <input
        id="bccRecipients"
        type="text"
        class="form-input mb-2"
        [ngClass]="{
          'form-input--invalid': bccRecipientsControl.invalid && (bccRecipientsControl.touched || bccRecipientsControl.touched),
        }"
        formControlName="bccRecipients"
        placeholder="email@example.com"
      />
      <ng-container *ngIf="bccRecipientsControl.invalid && (bccRecipientsControl.touched || bccRecipientsControl.touched)">
        <div *ngIf="bccRecipientsControl.hasError('email')" class="invalid-feedback">Invalid Email</div>
      </ng-container>
      <mat-hint>Comma-separated for multiple recipients</mat-hint>
    </div>
  </div>
</div>
